// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterTermsAndConditionsWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  GetTermSetWebApiResponseDto,
  MarkAcceptedTermsWebApiRequestDto,
  MarkAcceptedTermsWebApiResponseDto,
  TermSetId,
} from '../..';

interface GetTermSetParams {
  termSetId: TermSetId;
}

export const CappsRenterTermsAndConditionsWebApiHandler_getTermSet_Path =
  '/api/web/renter/v1/termsAndConditions/getTermSet';

export const CappsRenterTermsAndConditionsWebApiHandler_getTermSet = (
  getParams: GetTermSetParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetTermSetParams, never, GetTermSetWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: CappsRenterTermsAndConditionsWebApiHandler_getTermSet_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};

export const CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Path =
  '/api/web/renter/v1/termsAndConditions/markAcceptedTerms';

export const CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms = (
  postData: MarkAcceptedTermsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MarkAcceptedTermsWebApiRequestDto, MarkAcceptedTermsWebApiResponseDto>(
    {
      endpoint: CappsRenterTermsAndConditionsWebApiHandler_markAcceptedTerms_Path,
      method: 'POST',
      contextPath: '/capps',
      postData: postData,
    },
    client,
  );
};
